import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';

function ProductMaterialSearch({ setProductMaterial, materialIsVisible }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [search, setSearch] = React.useState('');
  const [material, setMaterial] = React.useState()
  const [fromBarkod, setFromBarkod] = React.useState(false);
  const { t } = useTranslation('overview');
  const SessionUser = getUser();

  console.log(materialIsVisible)

  React.useEffect(() => {
    if (search.length > 4) {
      axios.get(`/GetSiriusMaterialsByName/${search}/1/1/1/1/${SessionUser.ServiceShopId}`)
        .then((res) => {
          const response = res.data;
          if (response.length > 0) {
            setOptions(response);
          } else {
            setOptions([]);
          }
        }).catch((err) => {
          setOptions([]);
        });
    }
  }, [search]);

  const updateMaterial = (model) => {
    //setModel(model);
    console.log(model)
    setProductMaterial(model)
    // value.ACIKLAMA = model.ACIKLAMA;
    // value.KUL_MODEL_KODU = model.KUL_MODEL_KODU;

  };

  if (materialIsVisible) {
    return (
      <Autocomplete
        id="asynchronous-demo1"
        open={open}
        value={material}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        getOptionLabel={(option) => (option.MaterialId ? (`${option.MaterialCode} - ${option.MaterialDesc}`) : '')}
        options={options}
        filterOptions={(options, state) => options}
        loading={loading}
        onChange={(event, newValue) => {
          if (newValue && newValue.MaterialId) {
            updateMaterial(newValue);
          }
          else {
            setMaterial()
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            size="small"
            onChange={(e) => { setSearch(e.target.value); }}
            variant="outlined"
            label={t('lblMaterial')}
            // helperText={value ? value.ACIKLAMA : ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  }
  else {
    return <div></div>
  }

}

export default ProductMaterialSearch;
